import styled, { css } from 'foundations-theming-specialty/utils';
import { getTypographyStyles } from 'breadcrumbs-ui/components/Text';
import { MenuItemButton } from '../../../components/Menu';
import { getAccountMenuBorder, getAccountMenuItemPadding } from '../../../components/Accounts/shared-styles';
import { useAppDispatch } from '../../../hooks';
import { setDisplayFeedbackModal } from '../../../reducers/AppConfig';
import { useCallback } from 'react';
import { FeedbackIcon } from 'breadcrumbs-ui/icons';
import { FEEDBACK_MODAL_REDESIGN_TRELLIS_FEEDBACK } from '../../../components/FeedbackModal/constants';
import { useTranslation } from '../../../hooks/useNavConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMenuItem = styled(MenuItemButton)(({
  theme
}) => css(["list-style-type:none !important;border-bottom:", " !important;position:relative;button,a{color:", " !important;position:relative;background-color:transparent;max-width:290px;", " border:0;margin:0;width:100%;padding:", " !important;display:flex;text-decoration:none;text-align:left;align-items:center;span{color:", " !important;margin-left:", " !important;font-size:14px !important;}&:hover,&:focus{text-decoration:underline !important;}svg{fill:", " !important;}}"], getAccountMenuBorder(theme), theme.color['text-core-default'], getTypographyStyles(theme, 'body-125'), getAccountMenuItemPadding(theme), theme.color['text-core-default'], theme.space[200], theme.color['icon-core-subtle']));
const TrellisFeedback = () => {
  const dispatch = useAppDispatch();
  const {
    t
  } = useTranslation();
  const updateOptinState = useCallback(() => {
    dispatch(setDisplayFeedbackModal({
      displayFeedbackModal: FEEDBACK_MODAL_REDESIGN_TRELLIS_FEEDBACK
    }));
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(StyledMenuItem, {
    id: "hs-accounts-trellis-optin-out",
    onClick: updateOptinState,
    "data-test-id": "trellis-feedback-toggle",
    children: [/*#__PURE__*/_jsx(FeedbackIcon, {}), /*#__PURE__*/_jsx("span", {
      children: t('nav.trellis.shareFeedback')
    })]
  });
};
export default TrellisFeedback;